import React from "react";

import DashboardTimelineItem from "./timeline-item";



class DashboardTimeline extends React.Component {

    render() {
        const { reports } = this.props;
        return (
            <div>
                {
                    reports.map((item, i) =>
                        <DashboardTimelineItem item={item} key={i} />
                    )}
            </div>
        )
    }
}
export default DashboardTimeline;


// WEBPACK FOOTER //
// ./src/views/dashboard/timeline.js